import { useApiCall } from "@jane/lib/src/api";
import {FC} from "react";
import {config} from "../config";
import {LearnModule} from "../../../lib/src/api/repositories/learn-repository";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const ArchiveLearnModuleModal: FC<{ module: LearnModule, onFinished: () => void }> = (props) => {
  const {learn} = useApiCall(config)

  const archive = async () => {
    await learn.archiveModule(props.module)
    props.onFinished()
  }

  const unarchive = async () => {
    await learn.restoreModule(props.module)
    props.onFinished()
  }

  return <div className={"flex flex-col space-y-3"}>
    {props.module.archived_at ? <div>Weet je zeker dat je de volgende module terug wilt zetten?</div> :
    <div>Weet je zeker dat je de volgende module wilt archiveren?</div>
    }
    <div className={'font-bold'}>&middot; {props.module.name}</div>
    <ModalFooter text={'Opslaan'} onSubmit={props.module.archived_at ? unarchive : archive} />
  </div>
}